import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Modal from "react-bootstrap/Modal";
import { compareAsc, format } from 'date-fns'
import moment from "moment";
import { Link } from 'react-router-dom';

function HolidayListCom() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userId = localStorage.getItem('userId');

    const [id, setId] = useState('');
    const [modalstatus, setModalstatus] = useState(false);
    const [onaccountoff, setOnaccountoff] = useState('');
    const [date, setDate] = useState('');
    // const [day, setDay] = useState('');
    const [holidaytype, setHolidaytype] = useState('');
    const [holidaylist, setHolidaylist] = useState([]);
    const [err, setErr] = useState('');
    const [msg, setSmg] = useState('');
    const [country, setCountry] = useState('');
    const [countrylist, setCountrylist] = useState([]);

    const [day_level, setDay_level] = useState(['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'])
    const [holidayType, setHolidayType] = useState(['---', 'Restricted Holiday', 'Gazetted Holiday', 'National Holiday'])

    const get_oermission_data = useSelector((state) => state);
    const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
    const hr_permission = get_oermission_data.login_Permission.permissions

    const hr_permission_arr = Array()
    if (hr_permission) {
        const hr_permission_arr1 = JSON.parse(hr_permission).split(",")
        hr_permission_arr1.map((item, ind) => {
            hr_permission_arr.push(item);
        })
    }

    const showModal = () => {
        setModalstatus(true)
    }
    const handleClose = () => {
        setDate('');
        setOnaccountoff('')
        setHolidaytype('');
        setCountry('')
        setErr('')
        setSmg('')
        setId('')
        setModalstatus(false)
        setErrcountry('')
        setErronaccountof('')
        setErrdate('')
        setErrholidaytype('')
    }
    function addHoliday() {

        const response = fetch(SERVER_URL + `api/holiday/add-holiday`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    levelName: onaccountoff,
                    holidayDate: date,
                    status: 1,
                    holidayType: holidaytype,
                    location_id: country,
                    requestedBy: userId
                }),
            }).then(res => res.json())
            .then(data => {
                setErr('green');
                setSmg('Holiday create successfully')
                setTimeout(function () {
                    getholidayList()
                    handleClose()
                }, 1000);

            })
    }
    function editHoliday() {
        const user_login_id = localStorage.getItem('userId')
        const response = fetch(SERVER_URL + `api/holiday/update-holiday`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    holidayID: id,
                    levelName: onaccountoff,
                    holidayDate: date,
                    status: '1',
                    locationId: country,
                    holidayType: holidaytype,
                    requestedBy: user_login_id
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status = true) {
                    setErr('green');
                    setSmg('Holiday update successfully')
                    setTimeout(function () {
                        getholidayList()
                        handleClose()
                    }, 1000);
                }
            })

    }


    const getholidayById = async (id) => {
        setId(id)
        const response = await fetch(SERVER_URL + `api/holiday/single-holiday-details`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    holidayID: id
                }),
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    var resdata = data.result
                    setCountry(resdata.location_id)
                    setHolidaytype(resdata.holiday_type)
                    setOnaccountoff(resdata.level)
                    setDate(resdata.holiday_date)
                    setDate(moment(resdata.holiday_date).format('yyyy-MM-DD'))
                    setModalstatus(true)
                }
            })
    }
    useEffect(() => {
        getholidayList()
        getCountryList()
    }, [])
    const getholidayList = async (pagenumber) => {
        const response = await fetch(SERVER_URL + `api/holiday/office-holiday-list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setHolidaylist(data.result)
                }

            });
    }
    const handleDelete = (id) => {
        const user_login_id = localStorage.getItem('userId')
        const response = fetch(SERVER_URL + `api/holiday/update-holiday-delete`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    holidayID: id,
                    is_deleted: 1,
                    updatedRequestId: user_login_id
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status = true) {
                    getholidayList()
                }
            })
    }
    const getCountryList = () => {
        const response = fetch(SERVER_URL + `api/common/country_list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    //	setComplist(data.result)
                    setCountrylist(data.result)

                }
            });
    }

    const [errcountry, setErrcountry] = useState('')
    const [erronaccountof, setErronaccountof] = useState('')
    const [errdate, setErrdate] = useState('')
    const [errholidaytype, setErrholidaytype] = useState('')
    const handleSaveHoliday = () => {
        setErrcountry('')
        setErronaccountof('')
        setErrdate('')
        setErrholidaytype('')
        const reg_on_acc_of = /^(?!\s*$)[-a-zA-Z0-9_:,.\s]{1,100}$/
        if (country == '' || country == null || country == undefined) {
            setErrcountry('red')
            return false;
        }
        if (onaccountoff === '') {
            setErronaccountof('red')
            return false;
        }
        if (date == '' || date == null || date == undefined) {
            setErrdate('red')
            return false;
        }
        if (holidaytype == '' || holidaytype == null || holidaytype == undefined) {
            setErrholidaytype('red')
            return false;
        } else {
            if (id != '') {
                editHoliday()
            } else {
                addHoliday()
            }
        }
    }
    return (
        <>
            <Modal show={modalstatus} size="md" id="confirm_login">
                <div className="modal-body">
                    <div className="decorative-shape shape-1"></div>
                    <div className="decorative-shape shape-2"></div>
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross fw-bold"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{id ? 'Edit Holiday' : 'Add Holiday'}</div>
                    <form>
                        <div className="mb-2">
                            <label className="col-form-label">Country</label>
                            <select style={{ borderColor: errcountry }} value={country} onChange={e => setCountry(e.target.value)} className="form-select">
                                <option value="">Select Country</option>
                                {
                                    countrylist?.map((item, ind) => {
                                        return <option key={ind} value={item.id}>{item.name}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div className="mb-2">
                            <label className="col-form-label">On Account Of</label>
                            <input style={{ borderColor: erronaccountof }} type="text" onChange={(e) => { setOnaccountoff(e.target.value) }} value={onaccountoff} className="form-control" placeholder="" />
                        </div>
                        <div className="mb-2">
                            <label className="col-form-label">Date</label>
                            <input style={{ borderColor: errdate }} type="date" value={date} onChange={(e) => { setDate(e.target.value) }} className="form-control" />
                        </div>

                        <div className="mb-3">
                            <label className="col-form-label">Holiday Type</label>
                            <select style={{ borderColor: errholidaytype }} onChange={(e) => { setHolidaytype(e.target.value) }} value={holidaytype} className="form-select">
                                <option value=''>Select holiday type</option>
                                <option value='1'>Restricted Holiday</option>
                                <option value='2'>Gazetted Holiday</option>
                                <option value='3'>National Holiday</option>
                            </select>
                        </div>
                        {/* <div className="mb-2">
                            <div className="form-check formcheck1">
                                <input className="form-check-input" type="checkbox" value="" id="level1" />
                                <label className="form-check-label" htmlFor="level1">
                                    Major Festival
                                </label>
                            </div>
                        </div> */}
                    </form>
                    <div className="modalfooter">
                        <span className="d-block text-right mb10" style={{ color: err }}>{msg}</span>
                        <div className="row">
                            <div className="col-md-6 pr07">
                                <button type="button" onClick={handleSaveHoliday} className="btn_5 w-100">{id ? 'Update' : 'Save'}</button>
                            </div>
                            <div className="col-md-6 pl07">
                                <button type="button" onClick={handleClose} className="btn_6 w-100" data-bs-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <div className="page-header">
                <h1>List of Holidays
                    {
                        (hr_permission_arr?.includes('39') && <button href="" className="btn_5 mr10 float-end" onClick={showModal}>Add Holiday</button>)
                    }
                </h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> List of Holidays
                    </li>
                </ul>
            </div>

            <div className="row_bg">
                <table className="table_style_1">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Date</th>
                            <th>Day</th>
                            <th>On Account Of</th>
                            <th>Location</th>
                            <th>Holiday Type</th>
                             <th style={{ width: "150px" }}>Actions</th> 
                        </tr>
                    </thead>
                    <tbody>
                        {
                            holidaylist.map((item, ind) => {
                                return <tr key={ind}>
                                    <td>{ind + 1}</td>
                                    <td>{moment(item.holiday_date).format('DD MMM, yyyy')}</td>
                                    <td>{moment(item.holiday_date).format('dddd')}</td>
                                    <td>{item.level}</td>
                                    <td>{item.country_name}</td>
                                    <td>{holidayType[item.holiday_type]}</td>
                                    <td>
                                        {
                                            (hr_permission_arr?.includes('40') && <button onClick={(e) => { getholidayById(item.id) }} className="btn_7 mr03">Edit</button>)
                                        }
                                        {
                                            (hr_permission_arr?.includes('41') && <button onClick={(e) => { handleDelete(item.id) }} className="btn_8">Delete</button>)
                                        }


                                    </td> 
                                </tr>
                            })
                        }
                    </tbody>
                </table>
                {/* <p className="fs14 mt10">There are three National Holidays in India, 26th January, 15th August and 2nd October and there is a Major festivals (Holi 7th March, 2023).</p> */}

            </div>
        </>
    )
}

export default HolidayListCom
